import {
  getAllUserSubscriptions,
  listProductAccess
} from '@deque/billing-utils';
import type { ProductSlugs } from '~/common/constants';
import { useAuthContext } from '~/common/contexts/auth';
import { useEnterprises } from '~/common/contexts/enterprises';
import {
  hasAccessToProduct,
  hasAnyActiveSubscription
} from '~/common/utils/subscriptions';

export interface ConfigurationAccessState {
  userHasAccessToConfiguration: boolean;
  checkUserAccessToProduct: (slug: ProductSlugs) => boolean;
}
export const useConfigurationAccess = (): ConfigurationAccessState => {
  const { activeEnterprise, isAdmin: isEnterpriseAdmin } = useEnterprises();
  const { billingUser } = useAuthContext();

  // if user is admin show config even if the specific account doesn't have access to it
  // otherwise only consider user's own subscriptions
  const subscriptions =
    (activeEnterprise && isEnterpriseAdmin
      ? activeEnterprise.subscriptions
      : billingUser && getAllUserSubscriptions(billingUser, 'active-only')) ||
    [];

  const productAccess = listProductAccess(subscriptions);
  const enterpriseProductAccess = listProductAccess(
    billingUser?.enterprises[0]?.subscriptions || []
  );

  // If the user has any active subscriptions, grant configuration access
  const userHasAccessToConfiguration = hasAnyActiveSubscription({
    productAccess
  });

  // If there is an active enterprise, ensure the user has a subscription to the product from the enterprise
  const checkUserAccessToProduct = (slug: ProductSlugs) =>
    hasAccessToProduct({
      productAccess:
        activeEnterprise && !isEnterpriseAdmin
          ? enterpriseProductAccess
          : productAccess,
      slug
    });

  return { checkUserAccessToProduct, userHasAccessToConfiguration };
};
